import useThreeDS, { UseThreeDSProps } from '@/hooks/adyen/useThreeDS';
import { useLayoutEffect } from 'react';

const ThreeDSComponent = ({ action, handleOnAdditionalDetails, isGiftcard }: UseThreeDSProps) => {
  const { componentRef } = useThreeDS({
    action,
    handleOnAdditionalDetails,
    isGiftcard,
  });

  useLayoutEffect(() => {
    // @ts-ignore
    import(`@adyen/adyen-web/dist/adyen.css`);
  }, []);

  return (
    <div className="h-full">
      <div className="h-full" ref={componentRef}></div>
    </div>
  );
};

export default ThreeDSComponent;
